export default __webpack_public_path__ + "static/media/avatar_11.53abee7c.svg";